import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { JoinPage } from './pages/JoinPage';
import { PlayerPage } from './pages/PlayerPage';
import { AdminPage } from './pages/AdminPage';
import { DisplayPage } from './pages/DisplayPage';

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/admin')) {
      document.title = 'Rave Cave - Admin';
    } else if (pathname.startsWith('/display')) {
      document.title = 'Rave Cave - Display';
    } else {
      document.title = 'Rave Cave - Play';
    }
  }, [pathname]);

  return null;
}

export function App() {
  return (
    <>
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<JoinPage />} />
        <Route path="/join/:code" element={<JoinPage />} />
        <Route path="/play" element={<PlayerPage />} />
        <Route path="/scan/:token" element={<PlayerPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/display/:code" element={<DisplayPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
